import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { formatNumber } from '../../utils/chartDataUtils';
import styles from '../../styles/Team.module.css';

const ContentPerformanceChart = ({ data }) => {
  const chartData = data;

  if (!chartData || chartData.length === 0) {
    return (
      <div className={styles.chartPlaceholder}>
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>📝</div>
          <h3>No Content Performance Data Available</h3>
          <p>Content performance data will appear here once you have posts in the selected time period.</p>
        </div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <defs>
          <linearGradient id="postsGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#6366f1" stopOpacity={0.9}/>
            <stop offset="95%" stopColor="#6366f1" stopOpacity={0.4}/>
          </linearGradient>
          <linearGradient id="engagementGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.9}/>
            <stop offset="95%" stopColor="#f59e0b" stopOpacity={0.4}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" strokeOpacity={0.3} />
        <XAxis 
          dataKey="type" 
          stroke="#9ca3af"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis 
          stroke="#9ca3af"
          fontSize={12}
          tickFormatter={(value) => formatNumber(value)}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: '#1f2937',
            border: '1px solid #374151',
            borderRadius: '12px',
            color: '#f9fafb',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)'
          }}
          formatter={(value, name) => [formatNumber(value), name]}
          labelStyle={{ color: '#6366f1', fontWeight: 'bold' }}
        />
        <Legend 
          wrapperStyle={{
            paddingTop: '20px',
            color: '#f9fafb'
          }}
        />
        <Bar 
          dataKey="posts" 
          fill="url(#postsGradient)"
          radius={[4, 4, 0, 0]}
          name="Posts"
        />
        <Bar 
          dataKey="avgEngagement" 
          fill="url(#engagementGradient)"
          radius={[4, 4, 0, 0]}
          name="Avg Engagement"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ContentPerformanceChart; 